import { createReducer } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  status: null,
  message: null,
  data: null,
  modulesAccess: []
};

const auditUploadStatusReducer = createReducer(initialState, {
  UPLOAD_AUD_STATUS_REQ: (state) => {
    state.loading = true;
    state.data = null;
    state.modulesAccess = [];
  },
  UPLOAD_AUD_STATUS_SUC: (state, actions) => {
    const payload = actions.payload;
    state.loading = false;
    state.status = payload.status;
    state.message = payload.message;
    state.data = payload.data;
    state.modulesAccess = payload.modulesAccess;
  },
  UPLOAD_AUD_STATUS_ERROR: (state, actions) => {
    state.loading = false;
    state.status = null;
    state.message = null;
    state.data = null;
    state.modulesAccess = [];
  },
});

export default auditUploadStatusReducer;
